import { ethers } from "ethers";
import axios from "axios";
// import dotenv from "dotenv";
import pinataSDK from "@pinata/sdk";
import { formatEther } from "ethers"; // Required for formatting

import fs from "fs";
import { getContracts } from "../utils/getContracts";
import pinJSONToIPFS from "@pinata/sdk/types/commands/pinning/pinJSONToIPFS";

// dotenv.config();

const pinata = new pinataSDK({
  pinataJWTKey:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiI2NDgyZjkxZS0zNjNlLTQ5OWYtYjQ1ZC0wNzNmYzA4NmQxYTUiLCJlbWFpbCI6InRlaGlsYWZhdm91cml0ZUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJpZCI6IkZSQTEiLCJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MX1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiNTczMGRiYjgwNjhiZjFjYjdkYTUiLCJzY29wZWRLZXlTZWNyZXQiOiI1MTkyMmJmNDM1ZGUwYWM5YWMwN2UzYmE4NzQ1OGZiYzU5N2FjOTI3MzJhOTJjMGFlNjQyYmQ1OWNhZWRkMzk4IiwiaWF0IjoxNzAwMjA4NzQzfQ.t850Nq1NQGZTnpw-f-NEhVUrk892-UBFUWOp6hkiqnk",
});

// const pinata = new pinataSDK({ pinataJWTKey: REACT_APP_pinataJWT });
const abiCoder = new ethers.AbiCoder();

/// @notice Gets the length of the emission data array for a plant
/// @param _plant The address of the plant
/// @return The length of the emission data array
async function getAllUserEmissionLength(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const allUserEmissionLength =
    await basicInfrastructureContractInstance.getAllUserEmissionLength(address);
  return {
    allUserEmissionLength: ethers.formatEther(
      allUserEmissionLength.toString()
    ),
  };
}

async function dynamicAttributes(address: string, index: number) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const dynamicAttributes =
    await basicInfrastructureContractInstance.dynamicAttributes(address, index);
  const conditions = await basicInfrastructureContractInstance.conditions(
    address,
    index
  );
  return {
    reportingPeriod: dynamicAttributes.reportingPeriod,
    directStationaryEmissionsValue: ethers.formatEther(
      dynamicAttributes.directStationaryEmissionsValue.toString()
    ),
    totalGHGEmissions: ethers.formatEther(
      dynamicAttributes.totalGHGEmissions.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      dynamicAttributes.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
  };
}

async function userEmission(address: string) {
    const { basicInfrastructureContractInstance } = await getContracts();
  
    // Get the length of emission data for the user
    const emissionDataLength: number = await basicInfrastructureContractInstance.getAllPlantEmissionLength(
      address
    );
  
    // Retrieve all emission data for the user
    const allEmissionData: any[] = [];
  
    for (let i = 0; i < emissionDataLength; i++) {
      const allEmission = await basicInfrastructureContractInstance.allEmission(
        address,
        i
      );
      
      
  
      allEmissionData.push({
        directStationaryEmissionsValue: ethers.formatEther(
          allEmission.directStationaryEmissionsValue.toString()
        ),
        quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
          allEmission.quantifiedGHGEmissionsInBaselineScenario.toString()
        ),
        reportingPeriod: allEmission.reportingPeriod,
        totalGHGEmission: ethers.formatEther(
          allEmission.totalGHGEmissions.toString()
        ),
        isVerified: allEmission.isVerified,
      });
    }
  
    return allEmissionData;
  }

async function allEmission(address: string, index: number) {
  const { basicInfrastructureContractInstance } = await getContracts();
  const allEmission = await basicInfrastructureContractInstance.allEmission(
    address,
    index
  );
  return {
    reportingPeriod: allEmission.reportingPeriod,
    directStationaryEmissionsValue: ethers.formatEther(
      allEmission.directStationaryEmissionsValue.toString()
    ),
    totalGHGEmissions: ethers.formatEther(
      allEmission.totalGHGEmissions.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      allEmission.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    isVerified: allEmission.isVerified,
  };
}

// async function isPlantRecorded(address: string) {
//   const { basicInfrastructureContractInstance } = await getContracts();

//   const isRecorded = await basicInfrastructureContractInstance.isPlantRecorded(
//     address
//   );
//   return {
//     isRecorded,
//   };
// }

async function plantInfo(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const plantInfo = await basicInfrastructureContractInstance.plantInfo(
    address
  );
  return {
    address: plantInfo.plantAddress,
    name: plantInfo.name,
    scenario: plantInfo.scenario,
  };
}

async function getAllPlantsLength() {
  const { basicInfrastructureContractInstance } = await getContracts();

  const allPlantsLength =
    await basicInfrastructureContractInstance.getAllPlantsLength();
  return {
    allPlantsLength: ethers.formatEther(allPlantsLength.toString()),
  };
}

async function getPlantEmissionData(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const plantEmissionData =
    await basicInfrastructureContractInstance.getPlantEmissionData(address);
  return {
    plantEmissionData,
  };
}

async function getAllPlantEmissionLength(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();
  const allPlantEmissionLength =
    await basicInfrastructureContractInstance.getAllPlantEmissionLength(
      address
    );
  return {
    allPlantEmissionLength: ethers.formatEther(
      allPlantEmissionLength.toString()
    ),
  };
}

async function balanceOf(address: string) {
  const { closeCarbonTokenContractInstance } = await getContracts();
  const balance = await closeCarbonTokenContractInstance.balanceOf(address);
  return balance;
}

async function allEmissionValues(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();
  const allEmissionValues =
    await basicInfrastructureContractInstance.allEmissionValues(address);
  return {
    reportingPeriod: allEmissionValues.reportingPeriod,
    directStationaryEmissionsValue: ethers.formatEther(
      allEmissionValues.directStationaryEmissionsValue.toString()
    ),
    totalGHGEmissions: ethers.formatEther(
      allEmissionValues.totalGHGEmissions.toString()
    ),
    quantifiedGHGEmissionsInBaselineScenario: ethers.formatEther(
      allEmissionValues.quantifiedGHGEmissionsInBaselineScenario.toString()
    ),
    isVerified: allEmissionValues.isVerified,
  };
}

async function getStaticAttributes(address: string) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const staticAttributes =
    await basicInfrastructureContractInstance.getStaticAttributes(address);
  return {
    staticAttributes,
  };
}

// latest code for three-month accumulations
// Paged version: compute three-month accumulations for a page of plants.
// Returns a map keyed by plantAddress with the accumulation object for each plant
// async function getThreeMonthUnverifiedAccumulationsData(
//   start: number,
//   count: number
// ) {
//   try {
//     const { basicInfrastructureContractInstance } = await getContracts();

//     // fetch the plants page from the contract
//     const plantsData = await basicInfrastructureContractInstance.getPlantsData(
//       start,
//       count
//     );

//     // compute accumulations in parallel per plant (bounded by page size)
//     const promises = plantsData.map((p: any) =>
//       getThreeMonthUnverifiedAccumulationsForPlant(p.plantAddress).catch(
//         (e) => ({ error: String(e) })
//       )
//     );

//     const results = await Promise.all(promises);
//     const map: Record<string, any> = {};
//     for (let i = 0; i < plantsData.length; i++) {
//       const addr = plantsData[i].plantAddress;
//       map[addr] = results[i];
//     }

//     return map;
//   } catch (error: any) {
//     console.error("Error getting 3-month accumulations for page:", error);
//     return {};
//   }
// }

// Compute three-month accumulations for ALL plants by paging through all
// registered plants and aggregating page results. Returns a map keyed by plantAddress.
// async function getThreeMonthUnverifiedAccumulationsAll(pageSize = 50) {
//   try {
//     const { basicInfrastructureContractInstance } = await getContracts();

//     const totalBN: any = await basicInfrastructureContractInstance.getAllPlantsLength();
//     const total = typeof totalBN.toNumber === "function" ? totalBN.toNumber() : Number(totalBN);
//     const resultMap: Record<string, any> = {};

//     for (let start = 0; start < total; start += pageSize) {
//       const count = Math.min(pageSize, total - start);
//       const pageMap = await getThreeMonthUnverifiedAccumulationsData(start, count);
//       for (const addr of Object.keys(pageMap)) {
//         resultMap[addr] = pageMap[addr];
//       }
//     }

//     return resultMap;
//   } catch (error: any) {
//     console.error("Error getting 3-month accumulations for all plants:", error);
//     return {};
//   }
// }
// Returns accumulated unverified totals for the next three months (90 days)
// starting from the first unverified emission for the given plant.
async function getThreeMonthUnverifiedAccumulationsForPlant(
  plantAddress: string
) {
  try {
    const { basicInfrastructureContractInstance } = await getContracts();

    const emissionData = await basicInfrastructureContractInstance.getPlantEmissionData(
      plantAddress
    );

    // Query PlantRecorded events to get timestamps mapped by original index
    let eventTimestamps: any[] = [];
    try {
      const filter =
        basicInfrastructureContractInstance.filters.PlantRecorded(plantAddress);
      const events = await basicInfrastructureContractInstance.queryFilter(filter);
      events.sort((a: any, b: any) => {
        if (a.blockNumber !== b.blockNumber)
          return a.blockNumber - b.blockNumber;
        return a.logIndex - b.logIndex;
      });
      eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
    } catch (e) {
      eventTimestamps = [];
    }

    // find first unverified emission index
    let firstIdx: number | null = null;
    for (let i = 0; i < emissionData.length; i++) {
      if (!emissionData[i].isVerified) {
        firstIdx = i;
        break;
      }
    }

    if (firstIdx === null) {
      // nothing to accumulate
      return {
        energyConsumptionInKWh: "0.00",
        totalGHGEmission: "0.00",
        quantifiedGHGEmissionsInBaselineScenario: "0.00",
      };
    }

    // helper to convert a timestamp (BigNumber/number/string) to seconds (number)
    function toSeconds(ts: any): number | null {
      if (ts === undefined || ts === null) return null;
      let n: number;
      try {
        if (typeof ts === "object" && typeof ts.toNumber === "function") {
          n = ts.toNumber();
        } else {
          n = Number(ts);
        }
      } catch (e) {
        return null;
      }
      if (Number.isNaN(n)) return null;
      if (n > 1e12) return Math.floor(n / 1000);
      return Math.floor(n);
    }

    const startTs = toSeconds(
      eventTimestamps[firstIdx] ??
        emissionData[firstIdx].timestamp ??
        emissionData[firstIdx].issuedTime ??
        null
    );
    if (startTs === null) {
      // can't determine start time; return zeros
      return {
        energyConsumptionInKWh: "0.00",
        totalGHGEmission: "0.00",
        quantifiedGHGEmissionsInBaselineScenario: "0.00",
        facilityCapacity: "0.00",
        rangeStartDate: null,
        rangeEndDate: null,
        reportingPeriod: null,
        facilityName: null,
      };
    }

    const windowSeconds = 90 * 24 * 60 * 60; // 90 days
    const windowEnd = startTs + windowSeconds;

    // use BigInt sums to avoid precision loss (ethers v6 uses BigInt instead of BigNumber)
// use BigInt sums to avoid precision loss (ethers v6 uses BigInt instead of BigNumber)
let energySum = BigInt(0);
let totalGHGSum = BigInt(0);
let quantifiedGHGSum = BigInt(0);

    for (let i = 0; i < emissionData.length; i++) {
      const emission: any = emissionData[i];
      if (emission.isVerified) continue;

      const ts = toSeconds(
        eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null
      );
      if (ts === null) continue;
      if (ts < startTs || ts > windowEnd) continue;

      // emission fields are uint256 (wei-like) so sum them as BigInt
      try {
        energySum += BigInt(emission.energyConsumptionInKWh);
      } catch (e) {
        // if conversion fails, skip
        continue;
      }
      try {
        totalGHGSum += BigInt(emission.totalGHGEmission);
      } catch (e) {
        continue;
      }
      try {
        quantifiedGHGSum += BigInt(emission.quantifiedGHGEmissionsInBaselineScenario);
      } catch (e) {
        continue;
      }
    }

    // retrieve facility capacity and plant name/reportingPeriod
    let facilityCapacityFormatted = "0.00";
    let facilityName: string | null = null;
    let reportingPeriod: string | null = null;

    try {
      const plantInfoRaw = await basicInfrastructureContractInstance.plantInfo(
        plantAddress
      );
      facilityName = plantInfoRaw.organizationName || null;
    } catch (e) {
      facilityName = null;
    }

    try {
      const allEmissionVals =
        await basicInfrastructureContractInstance.allEmissionValues(plantAddress);
      // format facilityCapacity if present
      try {
        // Primary: expect a BigInt-like value (wei-style) and format it
        let capFormatted = "0.00";
        try {
          capFormatted = Number(
            ethers.formatEther(allEmissionVals.facilityCapacity)
          ).toFixed(2);
        } catch (innerErr) {
          // If it's not BigInt-like, maybe it's already a human-readable string/number
          if (
            allEmissionVals.facilityCapacity !== undefined &&
            allEmissionVals.facilityCapacity !== null
          ) {
            const asNum = Number(allEmissionVals.facilityCapacity);
            if (!Number.isNaN(asNum) && asNum !== 0) {
              capFormatted = asNum.toFixed(2);
            } else {
              capFormatted = "0.00";
            }
          }
        }
        facilityCapacityFormatted = capFormatted;
      } catch (e) {
        facilityCapacityFormatted = "0.00";
      }
    } catch (e) {
      facilityCapacityFormatted = "0.00";
    }

    // If aggregated facilityCapacity is still zero, try falling back to the
    // per-emission capacity stored on the first unverified emission (if present).
    if (facilityCapacityFormatted === "0.00") {
      try {
        const perEmissionCap = emissionData[firstIdx].facilityCapacity;
        if (perEmissionCap !== undefined && perEmissionCap !== null) {
          facilityCapacityFormatted = Number(
            ethers.formatEther(perEmissionCap)
          ).toFixed(2);
        }
      } catch (e) {
        // keep as "0.00" if fallback fails
      }
    }

    // reportingPeriod from first unverified emission (if exists)
    reportingPeriod = emissionData[firstIdx].reportingPeriod ?? null;

 const rangeStartDate = formatDate(new Date(startTs * 1000));
const rangeEndDate = formatDate(new Date(windowEnd * 1000));

function formatDate(date: Date): string {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}



    return {
      energyConsumptionInKWh: Number(
        ethers.formatEther(energySum)
      ).toFixed(2),
      totalGHGEmission: Number(ethers.formatEther(totalGHGSum)).toFixed(2),
      quantifiedGHGEmissionsInBaselineScenario: Number(
        ethers.formatEther(quantifiedGHGSum)
      ).toFixed(2),
      facilityCapacity: facilityCapacityFormatted,
      rangeStartDate,
      rangeEndDate,
      reportingPeriod,
      facilityName,
    };
  } catch (error: any) {
    console.error("Error getting 3-month unverified accumulations:", error);
    return {
      error: error.message || "Unknown error occurred",
    };
  }
}





async function getAllPlantsData() {
  const { basicInfrastructureContractInstance } = await getContracts();

  const getAllInfo =
    await basicInfrastructureContractInstance.getAllPlantsData();
  return {
    getAllInfo,
  };
}

async function getPlantsData(start: number, count: number) {
  const { basicInfrastructureContractInstance } = await getContracts();

  const getAllInfo =
    await basicInfrastructureContractInstance.getPlantsData(start, count);
    return {
      getAllInfo,
    };
}
// new 2026

async function getThreeMonthUnverifiedAccumulationCardsForPlant(
  plantAddress: string,
) {
  try {
    const { basicInfrastructureContractInstance } = await getContracts();

    const emissionData =
      await basicInfrastructureContractInstance.getPlantEmissionData(
        plantAddress,
      );

    let eventTimestamps: any[] = [];
    try {
      const filter =
        basicInfrastructureContractInstance.filters.PlantRecorded(plantAddress);
      const events = await basicInfrastructureContractInstance.queryFilter(
        filter,
      );
      events.sort((a: any, b: any) => {
        if (a.blockNumber !== b.blockNumber)
          return a.blockNumber - b.blockNumber;
        return a.logIndex - b.logIndex;
      });
      // In v6, event.args is an object with named properties
      eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
    } catch (e) {
      eventTimestamps = [];
    }

    function toSeconds(ts: any): number | null {
      if (ts === undefined || ts === null) return null;
      let n: number;
      try {
        // v6 returns bigint, so convert via BigInt then to number
        const bigVal = BigInt(ts);
        n = Number(bigVal);
      } catch (e) {
        return null;
      }
      if (Number.isNaN(n)) return null;
      if (n > 1e12) return Math.floor(n / 1000); // ms → seconds
      return Math.floor(n);
    }

    // Collect all unverified emissions with valid timestamps
    type Entry = { idx: number; ts: number; emission: any };
    const entries: Entry[] = [];
    for (let i = 0; i < emissionData.length; i++) {
      const emission: any = emissionData[i];
      if (emission.isVerified) continue;
      const ts = toSeconds(
        eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null,
      );
      if (ts === null) continue;
      entries.push({ idx: i, ts, emission });
    }

    if (entries.length === 0) {
      return [];
    }

    // Sort by timestamp ascending
    entries.sort((a, b) => a.ts - b.ts);

    // Pre-fetch plant-level metadata
    let facilityCapacityFormatted = "0.00";
    let facilityName: string | null = null;

    try {
      const plantInfoRaw = await basicInfrastructureContractInstance.plantInfo(
        plantAddress,
      );
      facilityName = plantInfoRaw.organizationName || null;
    } catch (e) {
      facilityName = null;
    }

    try {
      const allEmissionVals =
        await basicInfrastructureContractInstance.allEmissionValues(
          plantAddress,
        );
      try {
        let capFormatted = "0.00";
        try {
          // allEmissionVals.facilityCapacity is a bigint in v6
          capFormatted = Number(
            formatEther(allEmissionVals.facilityCapacity),
          ).toFixed(2);
        } catch (innerErr) {
          if (
            allEmissionVals.facilityCapacity !== undefined &&
            allEmissionVals.facilityCapacity !== null
          ) {
            const asNum = Number(allEmissionVals.facilityCapacity);
            if (!Number.isNaN(asNum) && asNum !== 0) {
              capFormatted = asNum.toFixed(2);
            } else {
              capFormatted = "0.00";
            }
          }
        }
        facilityCapacityFormatted = capFormatted;
      } catch (e) {
        facilityCapacityFormatted = "0.00";
      }
    } catch (e) {
      facilityCapacityFormatted = "0.00";
    }

    function formatDate(d: Date): string {
      const year = d.getUTCFullYear();
      const month = String(d.getUTCMonth() + 1).padStart(2, "0");
      const day = String(d.getUTCDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }

    const windowSeconds = 90 * 24 * 60 * 60; // 90 days
    const cards: any[] = [];

    let cardStartTs = entries[0].ts;
    let cardEndTs = cardStartTs + windowSeconds;
    // Use BigInt(0) instead of 0n to avoid bigint literals
    let energySum = BigInt(0);
    let totalGHGSum = BigInt(0);
    let quantifiedGHGSum = BigInt(0);
    let cardReportingPeriod: string | null =
      entries[0].emission.reportingPeriod ?? null;

    const flushCard = () => {
      // Compare with BigInt(0) using strict equality
      if (energySum === BigInt(0) && totalGHGSum === BigInt(0) && quantifiedGHGSum === BigInt(0)) {
        return;
      }

      let capacityForCard = facilityCapacityFormatted;
      if (capacityForCard === "0.00") {
        try {
          const perEmissionCap = entries[0].emission.facilityCapacity;
          if (perEmissionCap !== undefined && perEmissionCap !== null) {
            capacityForCard = Number(
              formatEther(perEmissionCap),
            ).toFixed(2);
          }
        } catch (e) {}
      }

      cards.push({
        directStationaryEmissionsValue: Number(
          formatEther(energySum),
        ).toFixed(2),
        totalGHGEmissions: Number(
          formatEther(totalGHGSum),
        ).toFixed(2),
        quantifiedGHGEmissionsInBaselineScenario: Number(
          formatEther(quantifiedGHGSum),
        ).toFixed(2),
        facilityCapacity: capacityForCard,
        rangeStartDate: formatDate(new Date(cardStartTs * 1000)),
        rangeEndDate: formatDate(new Date(cardEndTs * 1000)),
        reportingPeriod: cardReportingPeriod,
        facilityName,
      });
    };

    for (const { ts, emission } of entries) {
      // If this emission is beyond current card window, flush and start new card
      if (ts > cardEndTs) {
        flushCard();
        cardStartTs = ts;
        cardEndTs = cardStartTs + windowSeconds;
        energySum = BigInt(0);
        totalGHGSum = BigInt(0);
        quantifiedGHGSum = BigInt(0);
        cardReportingPeriod = emission.reportingPeriod ?? null;
      }

      // directStationaryEmissionsValue
      const energyVal = emission.directStationaryEmissionsValue;
      if (energyVal !== undefined && energyVal !== null) {
        try {
          energySum = energySum + BigInt(energyVal);
        } catch (e) {
          try {
            energySum = energySum + BigInt(String(energyVal));
          } catch (inner) {}
        }
      }

      // totalGHGEmissions (plural)
      const totalGHVal = emission.totalGHGEmissions;
      if (totalGHVal !== undefined && totalGHVal !== null) {
        try {
          totalGHGSum = totalGHGSum + BigInt(totalGHVal);
        } catch (e) {
          try {
            totalGHGSum = totalGHGSum + BigInt(String(totalGHVal));
          } catch (inner) {}
        }
      }

      const quantifiedVal = emission.quantifiedGHGEmissionsInBaselineScenario;
      if (quantifiedVal !== undefined && quantifiedVal !== null) {
        try {
          quantifiedGHGSum = quantifiedGHGSum + BigInt(quantifiedVal);
        } catch (e) {
          try {
            quantifiedGHGSum = quantifiedGHGSum + BigInt(String(quantifiedVal));
          } catch (inner) {}
        }
      }
    }

    // Flush the last card
    flushCard();

    return cards;
  } catch (error: any) {
    console.error(
      "Error getting 3-month unverified accumulation cards (infrastructure):",
      error,
    );
    return {
      error: error.message || "Unknown error occurred",
    };
  }
}

async function getAllPlantsThreeMonthCards() {
  try {
    const { basicInfrastructureContractInstance } = await getContracts();

    const totalPlants = await basicInfrastructureContractInstance.getAllPlantsLength();

if (totalPlants === BigInt(0)) return [];
    const results: any[] = [];

    // Use BigInt(0) instead of 0n, and increment with BigInt(1)
    for (let i = BigInt(0); i < totalPlants; i = i + BigInt(1)) {
      const plantAddress = await basicInfrastructureContractInstance.allPlants(i);

      const cards = await getThreeMonthUnverifiedAccumulationCardsForPlant(plantAddress);

      if (Array.isArray(cards) && cards.length > 0) {
        results.push({
          plantAddress,
          cards,
        });
      }
    }

    return results;
  } catch (error: any) {
    console.error("Error getting all plants 3-month cards (infrastructure):", error);
    return {
      error: error.message || "Unknown error occurred",
    };
  }
}


// async function getThreeMonthUnverifiedAccumulationCardsForPlant(
//   plantAddress: string,
// ) {
//   try {
//     const { basicInfrastructureContractInstance } = await getContracts();

//     const emissionData =
//       await basicInfrastructureContractInstance.getPlantEmissionData(
//         plantAddress,
//       );

//     let eventTimestamps: any[] = [];
//     try {
//       const filter =
//         basicInfrastructureContractInstance.filters.PlantRecorded(plantAddress);
//       const events = await basicInfrastructureContractInstance.queryFilter(
//         filter,
//       );
//       events.sort((a: any, b: any) => {
//         if (a.blockNumber !== b.blockNumber)
//           return a.blockNumber - b.blockNumber;
//         return a.logIndex - b.logIndex;
//       });
//       eventTimestamps = events.map((ev: any) => ev.args?.timestamp ?? null);
//     } catch (e) {
//       eventTimestamps = [];
//     }

//     function toSeconds(ts: any): number | null {
//       if (ts === undefined || ts === null) return null;
//       let n: number;
//       try {
//         // v6 returns bigint, so convert via BigInt then to number
//         const bigVal = BigInt(ts);
//         n = Number(bigVal);
//       } catch (e) {
//         return null;
//       }
//       if (Number.isNaN(n)) return null;
//       if (n > 1e12) return Math.floor(n / 1000);
//       return Math.floor(n);
//     }

//     // Collect all unverified emissions with valid timestamps
//     type Entry = { idx: number; ts: number; emission: any };
//     const entries: Entry[] = [];
//     for (let i = 0; i < emissionData.length; i++) {
//       const emission: any = emissionData[i];
//       if (emission.isVerified) continue;
//       const ts = toSeconds(
//         eventTimestamps[i] ?? emission.timestamp ?? emission.issuedTime ?? null,
//       );
//       if (ts === null) continue;
//       entries.push({ idx: i, ts, emission });
//     }

//     if (entries.length === 0) {
//       return [];
//     }

//     // Sort by timestamp ascending
//     entries.sort((a, b) => a.ts - b.ts);

//     // Pre-fetch plant-level metadata
//     let facilityCapacityFormatted = "0.00";
//     let facilityName: string | null = null;

//     try {
//       const plantInfoRaw = await basicInfrastructureContractInstance.plantInfo(
//         plantAddress,
//       );
//       facilityName = plantInfoRaw.organizationName || null;
//     } catch (e) {
//       facilityName = null;
//     }

//     try {
//       const allEmissionVals =
//         await basicInfrastructureContractInstance.allEmissionValues(
//           plantAddress,
//         );
//       try {
//         let capFormatted = "0.00";
//         try {
//           capFormatted = Number(
//             formatEther(allEmissionVals.facilityCapacity),
//           ).toFixed(2);
//         } catch (innerErr) {
//           if (
//             allEmissionVals.facilityCapacity !== undefined &&
//             allEmissionVals.facilityCapacity !== null
//           ) {
//             const asNum = Number(allEmissionVals.facilityCapacity);
//             if (!Number.isNaN(asNum) && asNum !== 0) {
//               capFormatted = asNum.toFixed(2);
//             } else {
//               capFormatted = "0.00";
//             }
//           }
//         }
//         facilityCapacityFormatted = capFormatted;
//       } catch (e) {
//         facilityCapacityFormatted = "0.00";
//       }
//     } catch (e) {
//       facilityCapacityFormatted = "0.00";
//     }

//     function formatDate(d: Date): string {
//       const year = d.getUTCFullYear();
//       const month = String(d.getUTCMonth() + 1).padStart(2, "0");
//       const day = String(d.getUTCDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     }

//     const windowSeconds = 90 * 24 * 60 * 60; // 90 days
//     const cards: any[] = [];

//     let cardStartTs = entries[0].ts;
//     let cardEndTs = cardStartTs + windowSeconds;
//     let energySum = BigInt(0);
//     let totalGHGSum = BigInt(0);
//     let quantifiedGHGSum = BigInt(0);
//     let cardReportingPeriod: string | null =
//       entries[0].emission.reportingPeriod ?? null;

//     const flushCard = () => {
//       if (energySum === BigInt(0) && totalGHGSum === BigInt(0) && quantifiedGHGSum === BigInt(0)) {
//         return;
//       }

//       let capacityForCard = facilityCapacityFormatted;
//       if (capacityForCard === "0.00") {
//         try {
//           const perEmissionCap = entries[0].emission.facilityCapacity;
//           if (perEmissionCap !== undefined && perEmissionCap !== null) {
//             capacityForCard = Number(
//               formatEther(perEmissionCap),
//             ).toFixed(2);
//           }
//         } catch (e) {}
//       }

//       cards.push({
//         directStationaryEmissionsValue: Number(
//           formatEther(energySum),
//         ).toFixed(2),
//         totalGHGEmissions: Number(
//           formatEther(totalGHGSum),
//         ).toFixed(2),
//         quantifiedGHGEmissionsInBaselineScenario: Number(
//           formatEther(quantifiedGHGSum),
//         ).toFixed(2),
//         facilityCapacity: capacityForCard,
//         rangeStartDate: formatDate(new Date(cardStartTs * 1000)),
//         rangeEndDate: formatDate(new Date(cardEndTs * 1000)),
//         reportingPeriod: cardReportingPeriod,
//         facilityName,
//       });
//     };

//     for (const { ts, emission } of entries) {
//       if (ts > cardEndTs) {
//         flushCard();
//         cardStartTs = ts;
//         cardEndTs = cardStartTs + windowSeconds;
//         energySum = BigInt(0);
//         totalGHGSum = BigInt(0);
//         quantifiedGHGSum = BigInt(0);
//         cardReportingPeriod = emission.reportingPeriod ?? null;
//       }

//       const energyVal = emission.directStationaryEmissionsValue;
//       if (energyVal !== undefined && energyVal !== null) {
//         try {
//           energySum = energySum + BigInt(energyVal);
//         } catch (e) {
//           try {
//             energySum = energySum + BigInt(String(energyVal));
//           } catch (inner) {}
//         }
//       }

//       const totalGHVal = emission.totalGHGEmissions;
//       if (totalGHVal !== undefined && totalGHVal !== null) {
//         try {
//           totalGHGSum = totalGHGSum + BigInt(totalGHVal);
//         } catch (e) {
//           try {
//             totalGHGSum = totalGHGSum + BigInt(String(totalGHVal));
//           } catch (inner) {}
//         }
//       }

//       const quantifiedVal = emission.quantifiedGHGEmissionsInBaselineScenario;
//       if (quantifiedVal !== undefined && quantifiedVal !== null) {
//         try {
//           quantifiedGHGSum = quantifiedGHGSum + BigInt(quantifiedVal);
//         } catch (e) {
//           try {
//             quantifiedGHGSum = quantifiedGHGSum + BigInt(String(quantifiedVal));
//           } catch (inner) {}
//         }
//       }
//     }

//     flushCard();

//     return cards;
//   } catch (error: any) {
//     console.error(
//       "Error getting 3-month unverified accumulation cards (infrastructure):",
//       error,
//     );
//     return {
//       error: error.message || "Unknown error occurred",
//     };
//   }
// }

export {
  getThreeMonthUnverifiedAccumulationCardsForPlant,
getAllPlantsThreeMonthCards,
  // getThreeMonthUnverifiedAccumulationsData,
  // getThreeMonthUnverifiedAccumulationsAll,
  getThreeMonthUnverifiedAccumulationsForPlant,
  getPlantEmissionData,
  getAllUserEmissionLength,
  getAllPlantsLength,
  balanceOf,
  allEmissionValues,
  getStaticAttributes,
  // getAllPlantsData,
  allEmission,
  getAllPlantEmissionLength,
  plantInfo,
  dynamicAttributes,
  userEmission,
  getPlantsData
};
